import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class OssVatRateCannotBeEmptyError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.product.validation.oss-vat-rate.cannot-be-empty-error');
    }
}
